import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined'
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined'
import { haspermission } from '../../../../Script/Permission'
import { post, Token } from '../../../../Script/Session'
import Stylebutton from '../../../../components/buttons/stylebutton/Stylebutton'
import SubKathegorie from './SubKathegorie'
import Accordion from '@mui/joy/Accordion';
import AccordionDetails from '@mui/joy/AccordionDetails';
import AccordionGroup from '@mui/joy/AccordionGroup';
import AccordionSummary from '@mui/joy/AccordionSummary';
import { Autocomplete, Box, Button, Chip, IconButton, Input, Link, Modal, Typography } from '@mui/joy'
import DragHandleOutlinedIcon from '@mui/icons-material/DragHandleOutlined';
import Dropdown from '@mui/joy/Dropdown';
import Menu from '@mui/joy/Menu';
import MenuButton from '@mui/joy/MenuButton';
import MenuItem from '@mui/joy/MenuItem';
import MoreVert from '@mui/icons-material/MoreVert';
import Alert from '@mui/joy/Alert';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
function KatheGorie({ item, canedit, upd, list }) {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 })
  const [open, setopen] = useState(false)
  const [mousein, setmousein] = useState(false)
  const [hoverdel, sethoverdel] = useState(false)
  const [hovercreate, sethovercreate] = useState(false)
  const [conti, setconti] = useState(false)
  useEffect(() => {
    const handleClickOutside = () => {
      if (isOpen) {
        setIsOpen(false)
      }
    }
    if (isOpen) {
      document.addEventListener('click', handleClickOutside)
    }
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [isOpen])

  function del() {
    const body = {
      token: Token.get(),
      target: item.name,
      action: "deleteKathegorie"
    }
    let response = post(body, "/vergleiche/Sparten");
    if (response === "LOGOUT") {
      navigate("/")
    }
    if (response === "OK") {
      setalert(true);
      setTimeout(() => {
        upd()
      }, 3000);
    }

  }

  function handleClick(e) {
    setTimeout(() => {
      setMousePos({ x: "80%", y: e.clientY })
      setIsOpen(true)
    }, 5)
  }
  const [alert, setalert] = useState(false);
  const [create, setcreate] = useState(false);
  const [selectedValue, setSelectedValue] = useState(0);
  const handleValueChange = (event, newValue) => {
    setSelectedValue(newValue); // 'newValue' contains the selected option
    console.log(newValue); // log the selected option
  };
  function handleNamePost(newName, t) {
    if (newName === "Bitte setzen") {
      alert("Bitte einen gültigen Namen eingeben.");
      return;
    }
    const body = {
      token: Token.get(),
      action: "createSubKathegorie",
      name: newName,
      targetKathegorie: item.name,
      startkath: t + 1,
    };
    try {
      const response = post(body, "/vergleiche/Sparten");
      console.log("ergebniss ist: " + response);
      if (response === "LOGOUT") {
        navigate("/");
        return;
      }
      setTimeout(() => {
        navigate(`/VergleichsSubhome/${item.name}/${JSON.parse(response).id}`);
      }, 1000);

    } catch (error) {
      console.error("Fehler beim Erstellen:", error);
    }
  }
  function editname(){
      console.log("Debug :", item.name)
      let a;
      a = prompt("Bitte geben sie einen neuen Namen für diese Sparte an");
      if (!a){
        return;
      }
      const body = {
        token: Token.get(),
        action: "editkathegorie",
        name: item.name,
        newname: a,
      };
      let response = post(body, "/vergleiche/Sparten");
      if (response == "OK"){
        window.location.reload();
      }
  }
  return (
    <>

      {alert && (
        <Alert
          variant="soft"
          color="success"
          startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
          endDecorator={
            <Button size="sm" variant="solid" color="success" onClick={() => setalert(false)}>
              Schliesen
            </Button>
          }
        >
          Sie haben Erfolgreich die kathegorie Item gelöscht<br /> Neu laden um änderungen anzuzeigen!
        </Alert>
      )}
      {create && (
        <div style={{
          position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", backgroundColor: "white", display: "flex",
          width: "40%",
          height: "30%",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          flexDirection: "column",
          alignItems: "center",
          zIndex: "9999"
        }}>
          <div style={{ color: "white", height: "15%", width: "100%", backgroundColor: "#2b3142", alignItems: "center", justifyContent: "center", display: "flex", fontSize: "20px" }}>
            <p>Untersparte Erstellen</p>
          </div>
          <div style={{ width: "100%", backgroundColor: "transparent", height: "65%", display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
            <Input id='asdkjalksd2309490324590239048293048902ß384' placeholder='Unterspartename' />
            <Autocomplete
              placeholder='Übergeordnete Untersparte'
              options={
                item.subkathegories.length > 0
                  ? [...item.subkathegories, { name: "Keine", order: 0 }]
                  : [{ name: "Keine", order: 0 }]
              }
              getOptionLabel={(option) => option.name}
              onChange={
                handleValueChange
              }
            />
          </div>
          <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
            <div onClick={() => {
              setcreate(false);


            }}><Stylebutton buttonText={"Abbrechen"}></Stylebutton></div>
            <div
              onClick={() => {
                console.log(document.getElementById("asdkjalksd2309490324590239048293048902ß384").value)
                if (document.getElementById("asdkjalksd2309490324590239048293048902ß384").value != "") {
                  handleNamePost(document.getElementById("asdkjalksd2309490324590239048293048902ß384").value, selectedValue.order);
                }


              }}


            ><Stylebutton buttonText={"Speichern"}></Stylebutton></div>
          </div>

        </div>
      )}
      <div
        style={{
          marginTop: "1%",
          backgroundColor: "white",
          width: "96.5%",
          borderRadius: "15px",
          boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: "#2b3142",
          padding: "1rem",
          justifyContent: "space-between",
          zIndex: "100",
        }}
      >
        <AccordionGroup>
          <Accordion>
            <AccordionSummary>
              <Box sx={{ width: "40%", display: "flex", justifyContent: "space-between" }}>
                <Typography level='title-lg'>
                  {item.name}
                </Typography>
              </Box>

              {canedit && (
                <Dropdown>
                  <MenuButton
                    slots={{ root: IconButton }}
                    slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                  >
                    <MoreVert />
                  </MenuButton>
                  <Menu>
                    <MenuItem onClick={()=> editname()}>Sparte Bearbeiten</MenuItem>
                    <MenuItem onClick={(() => setcreate(true))}>Untersparte Hinzufügen</MenuItem>
                    <MenuItem sx={{ color: "red" }} onClick={() => del()}>Sparte löschen</MenuItem>
                  </Menu>
                </Dropdown>

              )}

            </AccordionSummary>
            {item.subkathegories
              .slice() // optional: um Originaldaten nicht zu verändern
              .sort((a, b) => a.order - b.order) // aufsteigend nach .order
              .map(a => (
                <AccordionDetails
                  key={a.id} // oder item.name, falls kein id-Feld
                  sx={{
                    backgroundColor: 'transparent',
                    '&:hover': {
                      color: 'lightblue',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }
                  }}
                >
                  <Box sx={{ display: "flex", width: "100%" }}>
                    <Link href={"VergleichsSubhome/" + item.name + "/" + a.id} sx={{ width: "67.5%" }}>{a.name}</Link>
                  </Box>
                </AccordionDetails>
              ))}
          </Accordion>
        </AccordionGroup>
      </div>

    </>
  )
}

export default KatheGorie
